import React from 'react';
import styled from 'styled-components';
import { CcIcon, CcButton } from '@utp/components-react';
import { Label } from '../..';

const NavigationMonthWrap = styled.div`
  display: flex;
  justify-content: space-between;
  .button.sc-cc-button {
    background-color: #fff;
    height: 40px;
    width: 40px;
  }
  label {
    line-height: 40px;
  }
  .button__text.sc-cc-button {
    color: var(--text-text01);
  }
  .button.sc-cc-button cc-icon {
    color: var(--neutrals-neutral01);
  }
  .button.sc-cc-button:hover cc-icon {
    color: var(--text-primary) !important;
  }
`;

function NavigationMonth(props: any) {
  const { currentMonth, currentYear, onNextMonth, onPrevMonth } = props;
  return (
    <NavigationMonthWrap>
      <CcButton onClick={onPrevMonth}>
        <CcIcon name="chevron-left" size={24} />
      </CcButton>
      <Label
        text={`${currentMonth} ${currentYear}`}
        color="var(--text-primary)"
        size={14}
        black
      />
      <CcButton onClick={onNextMonth}>
        <CcIcon name="chevron-right" size={24} />
      </CcButton>
    </NavigationMonthWrap>
  );
}

export default NavigationMonth;
